export default __webpack_public_path__ + "static/media/factory__5.403f2645.jpg";